import { Container } from "./styles";
import rahul from "../../assets/rahul.jpg";
import ScrollAnimation from "react-animate-on-scroll";

const SKILL_CATEGORIES: Record<string, string[]> = {
  "Programming Languages": ["Python", "Java", "C/C++", "JavaScript", "TypeScript", "Go", "PHP"],
  "Frameworks & Libraries": [
    "Next.js",
    "Node.js",
    "Express.js",
    "React",
    "Prisma",
    "Zod",
    "LangChain",
  ],
  "Developer Tools": ["Docker", "GitHub Actions", "Kafka", "New Relic", "Kubernetes", "AWS", "Git", "Postman", "Redis"],
  Databases: ["PostgreSQL", "MySQL", "MongoDB"],
  "Other / Infra & AI": ["Terraform", "Grafana", "Generative AI"],
};

export function About() {
  return (
    <Container id="about" className="container">
      <div className="about-card section-card">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={120}>
          <p>
            I'm a final-year Information Technology student at Goa Engineering College focused on cloud, DevOps and LLM-powered apps. I build reliable backend systems, infra-as-code, and AI integrations.
          </p>
        </ScrollAnimation>

        <div className="meta-row">
          <div>
            <h4>Education</h4>
            <p className="muted">B.E Information Technology — Goa Engineering College (2021 - 2025) | CGPA: 9.0</p>
          </div>
          <div>
            <h4>Recent Roles</h4>
            <p className="muted">Backend Developer (Node.js) — Nexocide · Marketing Intern — StockGrow</p>
          </div>
        </div>

        <div>
          <h4>All Skills</h4>
          {Object.entries(SKILL_CATEGORIES).map(([category, skills]) => (
            <div key={category} style={{ marginBottom: "0.8rem" }}>
              <h5 style={{ margin: "0 0 0.4rem 0", fontSize: "1.4rem", color: "var(--muted)" }}>{category}</h5>
              <div className="skills-wrap">
                {skills.map((s) => (
                  <span key={s} className="skill-badge">{s}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="achievements">
          <h4>Achievements</h4>
          <ul>
            <li>🏆 Global Rank 187 — Unstop</li>
            <li>🥇 Top 20 — Flipkart GRiD 6.0</li>
            <li>🏅 National Finalist — Fintech Olympiad 2024 & ICSI Quiz 2024</li>
            <li>🏅 Hackindia 2025 Regional Round Runner Up</li>
            <li>💵 $5000 Microsoft Azure grant + AWS credits</li>
          </ul>
        </div>
      </div>

      <div className="about-image">
        <div className="image-frame">
          <ScrollAnimation animateIn="fadeInRight" delay={140}>
            <img src={rahul} alt="Rahul R. Madawalkar" loading="lazy" decoding="async" />
          </ScrollAnimation>
        </div>
      </div>
    </Container>
  );
}
